import i18n from '~/components/i18n'
import { StepId } from './constants'
import { getDateWithoutTime } from '~/utils/helpers'
import dayjs from 'dayjs'

export function getStepHeadMessage(stepId: StepId): string {
  switch (stepId) {
    case StepId.MILK:
      return i18n.t('Enter basic information about your herd\'s milk production for the reference period to get started. If your breed is not listed in the dropdown, please choose the most similar one to your breed. You can then over write the default milk production values if appropriate.')
    case StepId.HERD:
      return i18n.t(`Please fill in the average number of animals on the farm for the reference year, and the actual number of animals sold and the number purchased. 
          If you indicate sold animals, the total milk footprint is reduced as a part of the emissions is allocated to the production of meat(the weight gain and used feed energy determine this).
          Dead animals are NOT included under sold animals, as the GHG footprint per milk / meat would be underestimated.`)
    case StepId.GRAZING:
      return i18n.t('Please provide the information to estimate the amount of grazing time, total days and average hours per day during the grazing period and the select the grazing type and grass quality.')
    case StepId.FEED:
      return i18n.t(`If you know dry matter intake (DMI) values or the fresh weight equivalent (FWI), select the first method. Otherwise, select the second method and the tool will estimate DMI.
          For the first method you can enter only dry matter weight or enter both dry matter and fresh weight if you know both values. If you want to the tool to calculate one of them for you, 
          enter the one you know and hit the Convert Weight button to calculate the other.`)
    case StepId.MANURE:
      return i18n.t(`Under manure management, only the manure that is collected while the herd is in the stable should be considered. 
          The tool automatically calculates the manure “production” during grazing. 
          Choose the a manure management types (excluding grazing) applicable to for each animal category in your herd. The percentage of the different management types should add up to 100 % per animal category . 
          If no manure management is selected for an animal category, grazing will be assumed.`)
    case StepId.ENERGY_PROCESSING:
      return i18n.t(`Select the source of energy and enter the amount used during your one year reference period.
          Include energy (fuel/electricity) used in the production of grass crops (grazing areas, hay, silage). 
          Energy used in the production of non-grass crops grown on farm and entered in the Cool Farm Tool, 
          is included in the Cool Farm Tool crop footprint and thus should NOT be included here`)
    case StepId.TRANSPORT:
      return i18n.t(`The incoming transport of operating resources—such as feed from the
        mill or fertilizer from the dealer—to your farm should be included. Calculate or estimate
        the weight of the goods and the distances transported for each mode of transport.
        Please only include outgoing transport routes up to the farm gate. Example: Milk
        collection by your dairy is not included. Be careful to avoid double counting. If you have
        added fuel data for goods transport on the previous tab, do not enter any transport data
        here.`)
    default:
      return ''
  }
}

function transformStringValues(value: any): any {
  if (typeof value === 'string') {
    return value.replace(/,/g, '.')
  }

  if (value == null) {
    return value
  }

  if (Array.isArray(value)) {
    return value.map(item => transformStringValues(item))
  }

  if (typeof value === 'object') {
    const transformed: any = {}
    Object.keys(value).forEach(key => {
      transformed[key] = transformStringValues(value[key])
    })
    return transformed
  }

  return value
}

export function preparePayload(data: any) {
  const transformedData = transformStringValues(data)

  if (transformedData.fertilizers && Array.isArray(transformedData.fertilizers)) {
    transformedData.fertilizers.forEach(fertilizer => {
      if (fertilizer?.applicationDate) {
        const date = getDateWithoutTime(fertilizer?.applicationDate)
        if(dayjs(date).isValid) {
          fertilizer.applicationDate = dayjs(date).format('YYYY-MM-DD')
        }
      }
      if(fertilizer?.emissionsInhibitors === '0') {
        fertilizer.emissionsInhibitors = null
      }
    })
  }

  return transformedData
}